import { useState } from 'react';
import { Chip, Menu, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useUpdateStatus } from 'app/domains/tasks';
import { TaskStatusEnumEnum } from 'shared/domains/apollo/generated/types';
import { isOverdue } from './utils/isOverdue';
import { getStatusTranslations } from '../../utils/taskStatus';
export function StatusChip(props) {
    var _a;
    const { dueDate, status, id } = props;
    const { updateStatus, loading } = useUpdateStatus();
    const [open, setOpen] = useState(false);
    const closeDropdown = () => setOpen(false);
    const toggleDropdown = () => setOpen(!open);
    const overDue = isOverdue({ date: dueDate, completed: status === TaskStatusEnumEnum.Completed });
    const statuses = getStatusTranslations();
    const { icon, label, appearance } = statuses[status];
    const handleStatusChange = (newStatus) => {
        updateStatus({ id, status: newStatus });
    };
    return (<Menu.Root open={open} onClose={closeDropdown} target={<Chip variant="outline" icon={loading ? <Loader /> : icon} label={label} appearance={(_a = overDue === null || overDue === void 0 ? void 0 : overDue.appearance) !== null && _a !== void 0 ? _a : appearance} onClick={toggleDropdown}/>}>
      <Menu.ItemRadio checked={status === TaskStatusEnumEnum.Todo} onChange={() => handleStatusChange(TaskStatusEnumEnum.Todo)}>
        <Falcon icon="circle"/>
        {statuses.todo.label}
      </Menu.ItemRadio>
      <Menu.ItemRadio checked={status === TaskStatusEnumEnum.InProgress} onChange={() => handleStatusChange(TaskStatusEnumEnum.InProgress)}>
        <Falcon icon="circle-half-stroke"/>
        {statuses.in_progress.label}
      </Menu.ItemRadio>
      <Menu.ItemRadio checked={status === TaskStatusEnumEnum.Completed} onChange={() => handleStatusChange(TaskStatusEnumEnum.Completed)}>
        <Falcon icon="circle-check"/>
        {statuses.completed.label}
      </Menu.ItemRadio>
    </Menu.Root>);
}
